import { render, staticRenderFns } from "./DataFiles.vue?vue&type=template&id=e2a42d9c&"
import script from "./DataFiles.vue?vue&type=script&lang=js&"
export * from "./DataFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports